import { Create, Form, Input, useForm, Row, Col } from '@pankod/refine-antd';
import { ITag } from 'interfaces';

export const TagCreate: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<ITag>({
    metaData: {
      fields: ['id'],
    },
  });

  return (
    <Create isLoading={queryResult?.isFetching} saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={8} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
